import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { branch, compose, renderNothing } from 'recompose';

import UnopenedPayPeriod from './UnopenedPayPeriod';
import OpenedPayPeriod from './OpenedPayPeriod';
import { getSelectedPayPeriodId } from '../selectors';
import { withPayPeriodDetails } from '../graphql/PayPeriodQueries';

const propTypes = exact({
  payPeriod: PropTypes.object.isRequired,
  isPayPeriodOpened: PropTypes.bool.isRequired,
  isPayPeriodClosed: PropTypes.bool.isRequired,
  isPayPeriodFinalized: PropTypes.bool.isRequired,
  eligibleForClose: PropTypes.bool.isRequired,
  userTimesheets: PropTypes.array.isRequired,
  // payPeriodId is only used as a variable to the query
  // eslint-disable-next-line react/no-unused-prop-types
  payPeriodId: PropTypes.number.isRequired,
  allMissingTicketNumbers: PropTypes.array.isRequired,
});

const PayPeriod = (props) => {
  const {
    payPeriod,
    isPayPeriodOpened,
    isPayPeriodClosed,
    isPayPeriodFinalized,
    eligibleForClose,
    userTimesheets,
    allMissingTicketNumbers,
  } = props;

  const renderPayPeriod = () => {
    if (isPayPeriodOpened) {
      return (
        <OpenedPayPeriod
          eligibleForClose={eligibleForClose}
          payPeriod={payPeriod}
          userTimesheets={userTimesheets}
          allMissingTicketNumbers={allMissingTicketNumbers}
        />
      );
    }
    return (
      <UnopenedPayPeriod
        isPayPeriodClosed={isPayPeriodClosed}
        isPayPeriodFinalized={isPayPeriodFinalized}
        payPeriod={payPeriod}
      />
    );
  };

  return (
    <div>
      {renderPayPeriod(payPeriod)}
    </div>
  );
};

PayPeriod.propTypes = propTypes;

const mapStateToProps = (state) => {
  return {
    payPeriodId: getSelectedPayPeriodId(state),
  };
};

const withRedux = connect(mapStateToProps, {});

const withHide = branch(
  (props) => { return props.payPeriodId === null; },
  renderNothing,
);

const enhance = compose(
  withRedux,
  withHide,
  withPayPeriodDetails,
);
export default enhance(PayPeriod);
